import imageUrlBuilder from "@sanity/image-url";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { sanityClient } from "../client";

const builder = imageUrlBuilder(sanityClient);

/**
 * Helper to generate image URLs from Sanity sources.
 * gracefully handles invalid sources by returning a placeholder builder.
 */
export function urlFor(source: SanityImageSource | undefined | null) {
  if (source && (source as any).asset && (source as any).asset._ref) {
    return builder.image(source);
  }

  // If not valid, log a warning and return a more complete dummy object
  // Using a check to avoid spamming logs if source is just undefined/null (common in loading states)
  if (source !== undefined && source !== null) {
    console.warn("urlFor received invalid source:", source);
  }

  // Dummy object matching common chained methods
  const dummyUrl = "/placeholder-image.png"; // Path to your placeholder

  // We use 'any' here to allow chaining any method without strict type errors for the dummy implementation
  const dummyBuilder: any = {
    width: () => dummyBuilder,
    height: () => dummyBuilder,
    fit: () => dummyBuilder,
    crop: () => dummyBuilder,
    auto: () => dummyBuilder,
    format: () => dummyBuilder,
    quality: () => dummyBuilder,
    url: () => dummyUrl,
  };

  return dummyBuilder;
}

/**
 * Convenience function to get a string URL directly
 */
export function getImageUrl(source: SanityImageSource | undefined | null) {
  return urlFor(source).url();
}
